import axios from "axios";
import { JobLeave, JobLeaveChecklist } from "types/JobLeave";
import { API_URL } from "../constants";

export async function fetchJobLeavesByOnboarding(
  companyId: string,
  onboardingId: string
): Promise<JobLeave[]> {
  const res = await axios.get(
    `${API_URL}/${companyId}/onboarding/${onboardingId}/job-leaves`
  );
  return (res.data.jobLeaves || []) as JobLeave[];
}

/** @deprecated Company-wide list kept for legacy; UI uses onboarding nesting. */
export async function fetchJobLeaves(
  companyId: string,
  filtersValue: Record<string, unknown> = {}
): Promise<JobLeave[]> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/fetch`,
    filtersValue
  );
  return (res.data.jobLeaves || []) as JobLeave[];
}

export async function fetchJobLeaveById(
  companyId: string,
  jobLeaveId: string
): Promise<JobLeave> {
  const res = await axios.get(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}`
  );
  return res.data.jobLeave as JobLeave;
}

export async function createJobLeave(
  companyId: string,
  onboardingId: string,
  data: { quitDate?: number | null; notes?: string | null } = {}
): Promise<JobLeave> {
  const res = await axios.post(
    `${API_URL}/${companyId}/onboarding/${onboardingId}/job-leaves`,
    data
  );
  return res.data.jobLeave as JobLeave;
}

export async function completeJobLeaveStep(
  companyId: string,
  jobLeaveId: string
): Promise<JobLeave> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/complete-step`
  );
  return res.data.jobLeave as JobLeave;
}

export async function reopenJobLeaveStep(
  companyId: string,
  jobLeaveId: string,
  step: string
): Promise<JobLeave> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/reopen-step`,
    { step }
  );
  return res.data.jobLeave as JobLeave;
}

export async function completeJobLeave(
  companyId: string,
  jobLeaveId: string
): Promise<JobLeave> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/complete`
  );
  return res.data.jobLeave as JobLeave;
}

export async function cancelJobLeave(
  companyId: string,
  jobLeaveId: string
): Promise<JobLeave> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/cancel`
  );
  return res.data.jobLeave as JobLeave;
}

export async function returnJobLeaveAsset(
  companyId: string,
  jobLeaveId: string,
  assetId: string
): Promise<JobLeaveChecklist> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/assets/${assetId}/return`
  );
  return res.data.checklist as JobLeaveChecklist;
}

export async function cancelJobLeaveSignature(
  companyId: string,
  jobLeaveId: string,
  signatureId: string
): Promise<JobLeaveChecklist> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/signatures/${signatureId}/cancel`
  );
  return res.data.checklist as JobLeaveChecklist;
}

export async function cancelJobLeaveRequest(
  companyId: string,
  jobLeaveId: string,
  leaveRequestId: string
): Promise<JobLeaveChecklist> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/leave-requests/${leaveRequestId}/cancel`
  );
  return res.data.checklist as JobLeaveChecklist;
}

export async function clearJobLeaveManagedUser(
  companyId: string,
  jobLeaveId: string,
  userId: string
): Promise<JobLeaveChecklist> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/managed-users/${userId}/clear`
  );
  return res.data.checklist as JobLeaveChecklist;
}

export async function clearJobLeaveOtherAssignment(
  companyId: string,
  jobLeaveId: string,
  type: string,
  id: string
): Promise<JobLeaveChecklist> {
  const res = await axios.post(
    `${API_URL}/${companyId}/job-leaves/${jobLeaveId}/assignments/clear`,
    { type, id }
  );
  return res.data.checklist as JobLeaveChecklist;
}
